import { api } from 'shared/api'
import { ExternalTriggerSchemas } from 'shared/api/requests/externalTrigger/schemas'

export const ExternalTriggerApi = {
  changeStatus: api.account.createPost({
    url: '/externalTrigger/changeStatus',
    schemas: ExternalTriggerSchemas.changeStatus,
  }),
}
